import { Bell, ListTodo, MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRightSidebar } from "@/contexts/RightSidebarContext";
import { useNotifications } from "@/hooks/useNotifications";
import { usePanel } from "@/navigation/panel";

/** Header buttons that bring back the utility panels (R7). */
export function NotificationBell() {
  const { currentEntity } = useRightSidebar();
  const { openUtility } = usePanel();
  const { unreadCount } = useNotifications();

  return (
    <div className="flex items-center gap-1">
      <Button
        variant="ghost"
        size="icon"
        className="h-8 w-8 relative"
        onClick={() => openUtility("tasks")}
        title="My Tasks"
        aria-label="My Tasks"
        data-testid="my-tasks-button"
      >
        <ListTodo className="h-4 w-4" />
      </Button>

      {currentEntity && (
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8 relative"
          onClick={() => openUtility("comments")}
          title="Comments"
          aria-label="Comments"
          data-testid="comments-button"
        >
          <MessageSquare className="h-4 w-4" />
        </Button>
      )}

      <Button
        variant="ghost"
        size="icon"
        className="h-8 w-8 relative"
        onClick={() => openUtility("notifications")}
        title="Notifications"
        aria-label="Notifications"
        data-testid="notifications-button"
      >
        <Bell className="h-4 w-4" />
        {unreadCount > 0 && (
          <span className="absolute -top-0.5 -right-0.5 h-4 min-w-4 px-0.5 rounded-full bg-destructive text-destructive-foreground text-[10px] font-medium flex items-center justify-center">
            {unreadCount > 9 ? "9+" : unreadCount}
          </span>
        )}
      </Button>
    </div>
  );
}
